/**
 * Check if the app is running in a mobile WebView environment
 * @returns true if running in mobile WebView, false otherwise
 */
export const isMobileWebView = (): boolean => {
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;

  // Check if running on mobile device
  const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
    userAgent.toLowerCase()
  );

  // Check if JavascriptChannel exists (specific to Flutter WebView)
  const hasJavascriptChannel = !!(window as any).Print;

  return isMobile && hasJavascriptChannel;
};

/**
 * Handle phone call action - uses JavascriptChannel on mobile WebView,
 * falls back to default tel: link on desktop/browser
 * @param phoneNumber - The phone number to call
 */
export const handlePhoneCall = (phoneNumber: string): void => {
  if (isMobileWebView()) {
    // Send message to mobile app via JavascriptChannel
    const win = window as any;
    if (win.Print && typeof win.Print.postMessage === 'function') {
      win.Print.postMessage(JSON.stringify({
        action: 'call',
        phoneNumber: phoneNumber
      }));
    }
  } else {
    // Desktop/browser fallback - use default tel: link
    window.location.href = `tel:${phoneNumber}`;
  }
};

